import { render, staticRenderFns } from "./CartsTotal.vue?vue&type=template&id=7482f00c&"
import script from "./CartsTotal.vue?vue&type=script&lang=js&"
export * from "./CartsTotal.vue?vue&type=script&lang=js&"
import style0 from "./CartsTotal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CartsTotal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports